import { Injectable } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ScrollService {

  disableNextScroll: boolean = false; // Initialisation du scroll indisponible

  private previousUrl: string = '';
  constructor(
    private router: Router,
    private route: ActivatedRoute,  // injection du service ActivatedRoute
    private viewportScroller: ViewportScroller){

      router.events.subscribe(async (val) => {
        if (val instanceof NavigationEnd) {
          if (this.previousUrl !== val.urlAfterRedirects) {
            console.log('Navigation end:', val.urlAfterRedirects);
                  if(!this.disableNextScroll) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
          this.disableNextScroll = false; // Réactivation du scroll

          // Vérifie si un fragment (#id) est présent et scroll à l'élément
          this.route.fragment.subscribe(fragment => {
            if (fragment) {
                setTimeout(() => {
                  this.viewportScroller.scrollToAnchor(fragment) // Small delay to adjust position after scrolling
                  setTimeout(() => {
                    const element = document.getElementById(fragment);
                    if (element) {
                      const offset = 80; // Adjust by 70px
                      const elementPosition = element.getBoundingClientRect().top + window.scrollY;
                      window.scrollTo({ top: elementPosition - offset, behavior: 'smooth' });
                    }
                  }, 50);
                }, 100)
            }
          });

          this.previousUrl = val.urlAfterRedirects; // Met à jour l'ancienne URL
        }
      }
      });
  }



}
